import { images } from './images'

export type Bonus = {
  number: string
  title: string
  body: string
  /** URL de la portada real; vacío = portada dibujada en código. */
  cover: string
}

/** Los 5 bonus reales del pack (ficha DPS-33 · Softball Season-Ready). */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Parent-Helper Playbook',
    body: 'One-page “hand it and go” cards for the parent or assistant who doesn’t know softball: what to say, where to stand and the two mistakes to watch for. Suddenly one coach covers the whole team.',
    cover: images.bonusCovers[0],
  },
  {
    number: '02',
    title: 'Softball Rules Made Simple for Coaches',
    body: 'The rules you can’t afford not to know, explained by situation in plain English — hitting, baserunning, defense and appeals — with the most common differences by level. A quick reference; always check your league’s rulebook.',
    cover: images.bonusCovers[1],
  },
  {
    number: '03',
    title: 'The Scorebook, Made Simple',
    body: 'Keep score without getting lost: the symbols, ten common plays scored step by step, a practice score sheet and a mini scorekeeper checklist — so you’re ready before the first game.',
    cover: images.bonusCovers[2],
  },
  {
    number: '04',
    title: 'Gear & Field Setup on Any Budget',
    body: 'What gear you really need vs. what you don’t, cheap homemade substitutes for every drill, and a visual guide to marking the field and stations fast.',
    cover: images.bonusCovers[3],
  },
  {
    number: '05',
    title: 'Softball Decoded: Terms & Positions',
    body: 'The jargon decoder for a new coach: a glossary by category, positions by number (1–9), the abbreviations in your plans and scorebook, and the baseball-vs-softball “false friends.”',
    cover: images.bonusCovers[4],
  },
]
